import { httpClientFunction } from 'domain/types';

const httpClient = (customFetch: httpClientFunction, queryParams = '') => (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    const queryParamsParsed = input.toString().includes('?') && queryParams !== '' ? `&${queryParams.replace('?', '')}` : queryParams;
    return new Promise((resolve, reject) => {
        customFetch(`${input}${queryParamsParsed}`, init)
            .then((response) => {
                if (response.status === 401) {
                    window.parent.location.reload();
                }

                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};
export default httpClient;
